
/*eslint-disable*/
import React, { useState, useRef, useEffect } from 'react'
import { NavBar } from 'components/NavBar/NavBar'
import { Flex, PageWrapper, MapHTMLComponentsOverlay, P } from 'styling/GlobalStyles'
import {
  GlobalViewContainer,
  GlobalViewWidgetsContainer,
  GLAvatar,
  MapLoadingPlaceholder,
  SelectedPinAction,
  SelectedPinContainer,
  SelectedPinName,
  SelectedPins,
} from './GlobalView.styled'
import { machineryIcon } from 'assets/icons/MachineryIcon'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Status, Wrapper } from '@googlemaps/react-wrapper'
import { LatLongContainer, ZonesOrangeCircle, ZonesSideMenu } from 'pages/Zones/Zones.styled'
import { ICreating, ILatLong } from 'types/zones.interface'
import { validationWithCoordinates } from 'utils/validationUtils'
import { checkInvalid, sortByCounterClockwiseOrderForPolygon } from 'utils/helpers'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { WorldIcon } from 'assets/icons/WorldIcon'
import { toast } from 'react-toastify'
import { PlusIcon } from 'assets/icons/PlusIcon'
import { DeleteIcon } from 'assets/icons/DeleteIcon'
import { RestartIcon } from 'assets/icons/RestartIcon'
import Check from 'assets/icons/Check'
import { computeArea, LatLng } from 'spherical-geometry-js'
import { setConfirmModal } from 'features/global/globalSlice'
import { AreaInputs } from './AreaInputs'
import { GlobalViewMap } from './GlobalViewMap'
import {
  addGlobalViewArea,
  deleteGlobalViewArea,
  updateGlobalViewArea,
  getGlobalViewAreas,
  getGlobalViewUsers,
  getGlobalViewMachines,
  getWorkerInfo,
  getMachineInfo,
} from 'features/globalView/globalViewSlice'
import { GLEmployeesWidget } from './Widgets/EmployeesWidget'
import { GLMachinesWidget } from './Widgets/MachinesWidget'
import { GLTasksWidget } from './Widgets/TasksWidget'
import { GlobalViewDetails, getInitials } from './GlobalViewDetails'
import { AskAI } from './AskAI'
import { GlobalViewFilter } from './GlobalViewFilter'
import { IGlobalViewFitlers, ISelectedPin } from 'types/global-view.interface'
import { ExpandIcon } from 'assets/icons/ExpandIcon'
import { XIcon } from 'assets/icons/XIcon'
import { GLFuelWidget } from './Widgets/FuelWidget'
import { GlobalViewEmployeesList } from './GlobalViewEmployeesList'
import { GlobalViewMachinesList } from './GlobalViewMachinesList'

export const GlobalView = () => {
  const [map, setMap] = useState<any>()
  const [mapType, setMapType] = useState('satellite')
  const [creating, setCreating] = useState<
    Pick<ICreating, 'areaName' | 'areaSize' | 'path' | 'currentlyCreating' | 'updating' | 'id'>
  >({ path: [], areaName: '', areaSize: null })
  const [currentlyAdding, setCurrentlyAdding] = useState<ILatLong>({ lat: null, lng: null })
  const [menuOpen, setMenuOpen] = useState(false)
  const [invalidFieldsCoords, setInvalidFieldsCoords] = useState<string[]>([]) // <--- VALID
  const currentlyCreatingPolygon = useRef(null)
  const currentlyAddingMarkers = useRef([])
  const [toggleAreaControls, setToggleAreaControls] = useState(false)
  const loadedPolygons = useRef([])
  const usersCluster = useRef(null)
  const machinesCluster = useRef(null)
  const [selectedPins, setSelectedPins] = useState<ISelectedPin[]>([])
  const [usersList, setUsersList] = useState({ open: false, type: null })
  const [machinesList, setMachinesList] = useState({ open: false, type: null })
  const dispatch = useDispatch<AppDispatch>()

  const [filter, setFilter] = useState<IGlobalViewFitlers>({
    users: false,
    machines: true,
    areas: false,
    open: false,
  })


  useEffect(() => { // Close all pins when right side list are open
    if (usersList.open || machinesList.open) {
      setSelectedPins(prev => prev.map(p => ({ ...p, opened: false })))
    }
  }, [usersList, machinesList])

  useEffect(() => {
    if (selectedPins.some(p => p.opened)) {

      if (usersList.open) {
        setUsersList({ type: null, open: false })
      }

      if (machinesList.open) {
        setMachinesList({ type: null, open: false })
      }
    }
  }, [selectedPins])

  const handleToggle = async (property: 'areas' | 'machines' | 'users') => {
    setFilter((prev) => {
      const copy = { ...prev }
      copy[property] = !copy[property]
      return copy
    })
    const usersStatus = usersList.type
    const machinesStatus = machinesList.type
    switch (property) {
      case 'areas':
        setToggleAreaControls(prev => !prev)
        dispatch(getGlobalViewAreas(null))
        loadedPolygons.current.forEach((p) => {
          p.polygon.setMap(null)
          p.label.setMap(null)
        })
        loadedPolygons.current = []
        currentlyAddingMarkers.current.forEach(m => m.setMap(null))
        currentlyAddingMarkers.current = []
        setCreating({ path: [], areaSize: null, areaName: '' })
        setMenuOpen(false)
        break
      case 'users':
        dispatch(getGlobalViewUsers({ status: usersStatus, initialLoading: true }))
        usersCluster.current?.setMap(null)
        usersCluster.current = null
        break;
      case 'machines':
        const resp = await dispatch(getGlobalViewMachines({ status: machinesStatus, initialLoading: true }))
        const dt = (resp.payload as any).data.machines.filter(d => d.vehicle) // TOOD Resiti any
        if (dt.length) {
          map.setCenter({ lng: dt[0].vehicle.longitude, lat: dt[0].vehicle.latitude })
          map.setZoom(10)
        }
        machinesCluster.current?.setMap(null)
        machinesCluster.current = null
        break;
    }
  }


  const handleMapType = () => {
    if (mapType == 'satellite') {
      map.setMapTypeId('terrain')
      setMapType('terrain')
    } else {
      map.setMapTypeId('satellite')
      setMapType('satellite')
    }
  }

  const handleMenuOpen = () => {
    if (creating.currentlyCreating) {
      toast.warn('Area already created, please enter area info.')
    } else {
      map.addListener('click', (e) => {
        setCreating((prev: ICreating) => {
          const copy = structuredClone(prev)
          currentlyAddingMarkers.current.push(
            new google.maps.Marker({
              position: { lat: e.latLng.lat(), lng: e.latLng.lng() },
              map,
            }),
          )
          copy.path.push({ lat: e.latLng.lat(), lng: e.latLng.lng() })
          if (copy.path.length > 2) {
            currentlyCreatingPolygon.current?.setMap(null)
            currentlyCreatingPolygon.current = new google.maps.Polygon({
              paths: copy.path,
              fillColor: '#fff',
              map,
              strokeWeight: 0.5,
            })
            copy.areaSize = Number(
              computeArea(copy.path.map((i: ILatLong) => new LatLng(i.lat, i.lng, false))).toFixed(4),
            )
          }
          return copy
        })
        setCurrentlyAdding({ lat: null, lng: null })
      })


      setMenuOpen(true)
      setCreating((prev) => {
        const copy = structuredClone(prev)
        copy.currentlyCreating = true
        return copy
      })
    }
  }

  const handleEnterCoords = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = e.target as HTMLInputElement
    let parsedValue = parseFloat(value)
    validationWithCoordinates(e, setInvalidFieldsCoords)
    if (isNaN(parsedValue)) {
      parsedValue = undefined
    }
    setCurrentlyAdding((prev) => {
      const copy = { ...prev }
      name == 'lat' ? (copy.lat = parsedValue) : (copy.lng = parsedValue)
      return copy
    })
  }


  const handleDone = async () => {
    if (!creating.areaName || creating.areaName.length < 2) {
      toast.warn('Area name must be valid.')
      return
    }
    if (creating.path.length < 3) {
      toast.warn('Area must have at least 3 points')
      return
    } else {
      google.maps.event.clearListeners(map, 'click')
      let resp: any
      if (creating.updating) {
        let path = []
        if (creating.path[0].lat == creating.path[creating.path.length - 1].lat &&
          creating.path[0].lng == creating.path[creating.path.length - 1].lng) {
          path = [...sortByCounterClockwiseOrderForPolygon(creating.path.slice(0, -1)), creating.path[creating.path.length - 1]]
        } else {
          path = [...sortByCounterClockwiseOrderForPolygon(path), path[0]]
        }
        resp = await dispatch(updateGlobalViewArea({
          areaName: creating.areaName, areaSize: creating.areaSize, id: Number(creating.id),
          path: path
        }))
      } else {
        resp = await dispatch(addGlobalViewArea({
          areaName: creating.areaName, areaSize: creating.areaSize,
          path: [...sortByCounterClockwiseOrderForPolygon(creating.path), sortByCounterClockwiseOrderForPolygon(creating.path)[0]]
        }))
      }
      if (resp.meta.requestStatus === 'fulfilled') {
        setCreating({ currentlyCreating: false, path: [], areaName: '', areaSize: null })
        setCurrentlyAdding({ lat: null, lng: null })
        setMenuOpen(false)
        currentlyCreatingPolygon.current?.setMap(null)
      }
    }
    currentlyAddingMarkers.current.forEach((m) => m.setMap(null))
    google.maps.event.clearListeners(map, 'click')
    !filter.areas && handleToggle('areas')
  }

  const handleAddCoords = () => {
    if (
      currentlyAdding.lat &&
      currentlyAdding.lng &&
      typeof currentlyAdding.lat == 'number' &&
      typeof currentlyAdding.lng == 'number' &&
      invalidFieldsCoords.length < 1
    ) {
      setCreating((prev: ICreating) => {
        const copy = structuredClone(prev)
        currentlyAddingMarkers.current.push(
          new google.maps.Marker({
            position: { lat: currentlyAdding.lat, lng: currentlyAdding.lng },
            map,
          }),
        )
        copy.path.push(currentlyAdding)
        if (copy.path.length > 2) {
          currentlyCreatingPolygon.current = new google.maps.Polygon({
            paths: copy.path,
            fillColor: '#fff',
            map,
            strokeWeight: 0.5,
          })
          copy.areaSize = Number(
            computeArea(copy.path.map((i: ILatLong) => new LatLng(i.lat, i.lng, false))).toFixed(4),
          )
        }
        return copy
      })
      setCurrentlyAdding({ lat: null, lng: null })
    } else {
      toast.error('Please enter valid coordinates')
    }
    map.setCenter({ lng: currentlyAdding.lng, lat: currentlyAdding.lat })
    map.setZoom(10)
  }

  const handleDeleteArea = async () => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteGlobalViewArea(Number(creating.id)))
          dispatch(setConfirmModal({ isOpen: false }))
        },
        word: 'delete area',
      }),
    )
    currentlyAddingMarkers.current.forEach(m => m.setMap(null))
    currentlyAddingMarkers.current = []
    setCreating({ currentlyCreating: false, path: [], areaName: '', areaSize: null })
    setCurrentlyAdding({ lat: null, lng: null })
    setMenuOpen(false)
    google.maps.event.clearListeners(map, 'click')

  }

  const handleUndo = () => {
    setCreating((prev: ICreating) => {
      const copy = structuredClone(prev)
      copy.path.pop()
      copy.areaSize = Number(
        computeArea(copy.path.map((i: ILatLong) => new LatLng(i.lat, i.lng, false))).toFixed(4),
      )
      currentlyCreatingPolygon.current?.setMap(null)
      currentlyCreatingPolygon.current = new google.maps.Polygon({
        paths: copy.path,
        fillColor: '#fff',
        map,
        strokeWeight: 0.5,
      })
      currentlyAddingMarkers.current[currentlyAddingMarkers.current.length - 1].setMap(null)
      currentlyAddingMarkers.current.pop()
      return copy
    })
  }

  const handleCancel = () => {
    setCreating({ currentlyCreating: false, path: [], areaName: '', areaSize: null })
    setCurrentlyAdding({ lat: null, lng: null })

    currentlyAddingMarkers.current.forEach(m => m.setMap(null))
    currentlyAddingMarkers.current = []

    if (currentlyCreatingPolygon.current) {
      currentlyCreatingPolygon.current.setMap(null)
      currentlyCreatingPolygon.current = null
    }

    setMenuOpen(false)
    google.maps.event.clearListeners(map, 'click')
  }


  const handleGetInfo = (i) => {
    setCreating({ ...i, currentlyCreating: true, updating: true })
    setMenuOpen(true)
    currentlyAddingMarkers.current = i.path.map(i => new google.maps.Marker({
      position: { lat: i.lat, lng: i.lng },
      map,
    }))
    setToggleAreaControls(true)
  }

  const handleSelectPin = (p: ISelectedPin, unselect?: boolean) => {

    if (unselect) {
      setSelectedPins(prev => {
        return prev.filter(pin => !(pin.id == p.id && pin.type == p.type)).map(p => ({ ...p, opened: false }))
      })
      return
    }

    if (p.type == 'employee') {
      dispatch(getWorkerInfo(p.id))
    } else {
      dispatch(getMachineInfo(p.id)) // TODO Uneselect fetch
    }
    setSelectedPins(prev => {
      const pin = prev.find(pp => pp.id == p.id && pp.type == p.type)
      if (!pin) {
        return [...prev.map(pr => ({ ...pr, opened: false })), p]
      }
      return [...prev.map(pr => ({ ...pr, opened: pr.id == p.id })), p]
    })
  }
  // export interface ISelectedPin {
  //   name: string
  //   id: number
  //   type: 'machine' | 'employee'
  //   showTrips?: boolean
  //   opened: boolean
  //   lastClosed?: boolean
  // }

  const handleOpenPin = (pin: ISelectedPin) => {
    setSelectedPins(prev => prev.map(p => ({ ...p, opened: (p.id == pin.id && p.type == pin.type) ? !p.opened : false, showTrips: false })))
  }

  const SelectedPin = ({ p }: { p: ISelectedPin }) => <SelectedPinContainer>
    {p.type === 'employee' ? (
      <GLAvatar>{getInitials(p.name)}</GLAvatar>
    ) : (
      <GLAvatar $machine>{machineryIcon}</GLAvatar>
    )}
    <SelectedPinName>{p.name}</SelectedPinName>
    <SelectedPinAction style={{ top: '1rem' }} onClick={() => handleSelectPin(p, true)} ><XIcon /></SelectedPinAction>
    <SelectedPinAction style={{ top: '3.2rem' }} onClick={() => handleOpenPin(p)}> <ExpandIcon /> </SelectedPinAction>
  </SelectedPinContainer>

  const handleMachineOpen = (open: boolean, type: number) => {
    setMachinesList({ open, type })
    setUsersList({ open: !open, type: null })
  }

  const handleUsersOpen = (open: boolean, type: string) => {
    setUsersList({ open, type })
    setMachinesList({ open: !open, type: null })
  }

  return (
    <>
      <PageWrapper fullHeight>
        <div className='App-map global-view-map-root'>
          <NavBar filterClick={() => setFilter(prev => ({ ...prev, open: !filter.open }))} />
          <GlobalViewContainer>
            <GlobalViewFilter handleToggle={handleToggle} filter={filter} />
            <GlobalViewWidgetsContainer closed={filter.open} >
              <GLEmployeesWidget selectedStatus={usersList.type} handleWidget={handleUsersOpen} />
              <GLMachinesWidget selectedStatus={machinesList.type} handleWidget={handleMachineOpen} />
              <GLTasksWidget />
              <GLFuelWidget />
            </GlobalViewWidgetsContainer >
            <AskAI />
            <SelectedPins closed={selectedPins.some(p => p.opened) || !selectedPins.length}>
              {
                selectedPins.map(p => <SelectedPin p={p} />)
              }
            </SelectedPins>
            <GlobalViewDetails map={map} handleClosePin={handleOpenPin} handleUnselectPin={handleSelectPin} setSelectedPins={setSelectedPins} openedPin={selectedPins.find(p => p.opened)} />
            <GlobalViewEmployeesList map={map} list={usersList} setList={setUsersList} />
            <GlobalViewMachinesList map={map} list={machinesList} setList={setMachinesList} />
          </GlobalViewContainer>

          {toggleAreaControls && (
            <MapHTMLComponentsOverlay globalView>
              {creating.currentlyCreating && (
                <AreaInputs
                  setCreating={setCreating}
                  creating={creating}
                  handleCancel={handleCancel}
                />
              )}
              <ZonesSideMenu>
                <ZonesOrangeCircle style={{ marginTop: '5rem' }} onClick={handleMapType}>
                  <WorldIcon />
                </ZonesOrangeCircle>

                {!menuOpen ? (
                  <ZonesOrangeCircle onClick={handleMenuOpen}>{PlusIcon}</ZonesOrangeCircle>
                ) : (
                  <Flex column alignEnd gap='1rem'>
                    <Flex gap='1rem' padding='0 1rem'>
                      {creating.updating && (
                        <ZonesOrangeCircle whiteIcon onClick={handleDeleteArea}>
                          {DeleteIcon}
                        </ZonesOrangeCircle>
                      )}
                      {currentlyCreatingPolygon.current && creating.path.length > 0 &&
                        <ZonesOrangeCircle onClick={handleUndo}>{RestartIcon}</ZonesOrangeCircle>}
                      <ZonesOrangeCircle onClick={handleCancel}>
                        <CloseIcon />
                      </ZonesOrangeCircle>
                      <ZonesOrangeCircle onClick={handleDone}>{<Check white />}</ZonesOrangeCircle>
                    </Flex>
                    <LatLongContainer>
                      <Input
                        labelText='Latitude'
                        placeholder='Type here'
                        type='number'
                        name='lat'
                        width='8rem'
                        nomarg
                        value={currentlyAdding.lat}
                        onChange={handleEnterCoords}
                        invalid={checkInvalid(invalidFieldsCoords, 'lat')}
                      />
                      <Input
                        nomarg
                        labelText='Longitude'
                        placeholder='Type here'
                        name='lng'
                        type='number'
                        width='8rem'
                        value={currentlyAdding.lng}
                        onChange={handleEnterCoords}
                        invalid={checkInvalid(invalidFieldsCoords, 'lng')}
                      />
                      <ZonesOrangeCircle onClick={handleAddCoords}>{PlusIcon}</ZonesOrangeCircle>
                    </LatLongContainer>
                  </Flex>
                )}
              </ZonesSideMenu>
            </MapHTMLComponentsOverlay>
          )}
          <Wrapper
            apiKey={process.env.REACT_APP_GOOGLE_KEY}
            version='beta'
            libraries={['marker']}
            render={(status) =>
              status === Status.SUCCESS ? (
                <GlobalViewMap
                  machinesTypeFilter={machinesList.type}
                  usersTypeFilter={usersList.type}
                  usersCluster={usersCluster}
                  machinesCluster={machinesCluster}
                  loadedPolygons={loadedPolygons}
                  filters={filter}
                  map={map}
                  setMap={setMap}
                  handleGetInfo={handleGetInfo}
                  handleSelectPin={handleSelectPin}
                />
              ) : (
                <MapLoadingPlaceholder aria-hidden />
              )
            }
          />
        </div>
      </PageWrapper>
    </>
  )
}

